<app-generic-field [label]="label" [hideLabel]="hideLabel">
  <div class="container">
    <div class="selectable" *ngFor="let option of options" [tabindex]="0" [style]="getColorStyle(option)"
         [class.selected]="selectedOption === option" [class.big-text]="selectedOption === option && highlightMode === 'size'"
         [class.increase-size-on-focus]="highlightMode === 'size'"
         (click)="selectOption(option)" (keydown.space)="selectOption(option)" (keydown.enter)="selectOption(option)">
      <div class="content">
        <div class="icon" *ngIf="option.icon"><i [className]="(option.icon.includes(' ') ? '' : 'fas ') + option.icon"></i></div>
        <div class="text" *ngIf="option.name">{{option.name}}</div>
        <div class="checked-icon" *ngIf="highlightMode === 'check'"><i *ngIf="option === selectedOption" class="fas fa-check"></i></div>
      </div>
    </div>
  </div>
</app-generic-field>
